import { render, staticRenderFns } from "./AlarmSetting.vue?vue&type=template&id=6436d355&scoped=true&"
import script from "./AlarmSetting.vue?vue&type=script&lang=js&"
export * from "./AlarmSetting.vue?vue&type=script&lang=js&"
import style0 from "./AlarmSetting.vue?vue&type=style&index=0&id=6436d355&lang=scss&scoped=true&"
import style1 from "./AlarmSetting.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6436d355",
  null
  
)

export default component.exports